import { useEffect } from 'react'
import { useAppSelector, useAppDispatch } from '../../../store/hooks.ts'
import { selectAuth } from '../../../store/auth/authSelectors.ts'
import { selectIsMobileSidebarOpen } from '../../../store/ui/uiSelectors.ts'
import { setMobileSidebarOpen } from '../../../store/ui/uiSlice.ts'
import SidebarButtonsWrapper from '../Sidebar/components/SidebarButtonsWrapper/SidebarButtonsWrapper.tsx'
import SidebarWorkspaceButton from '../Sidebar/components/SidebarWorkspaceButton/SidebarWorkspaceButton.tsx'
import SidebarPlateButton from '../Sidebar/components/SidebarPlateButton/SidebarPlateButton.tsx'
import SidebarTeamButton from '../Sidebar/components/SidebarTeamButton/SidebarTeamButton.tsx'
import SidebarProjectsButton from '../Sidebar/components/SidebarProjectsButton/SidebarProjectsButton.tsx'
import SidebarAllTasksButton from '../Sidebar/components/SidebarAllTasksButton/SidebarAllTasksButton.tsx'
import SidebarInboxButton from '../Sidebar/components/SidebarInboxButton/SidebarInboxButton.tsx'
import SidebarSearchButton from '../Sidebar/components/SidebarSearchButton/SidebarSearchButton.tsx'
import SidebarAuthButton from '../Sidebar/components/SidebarAuthButton/SidebarAuthButton.tsx'
import css from './MobileSidebar.module.css'

const MobileSidebar = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsMobileSidebarOpen)
    const auth = useAppSelector(selectAuth)

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden'
            document.documentElement.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = ''
            document.documentElement.style.overflow = ''
        }
        return () => {
            document.body.style.overflow = ''
            document.documentElement.style.overflow = ''
        }
    }, [isOpen])

    return (
        <>
            <div
                className={`${css.overlay} ${isOpen ? css.overlay_visible : ''}`}
                onClick={() => dispatch(setMobileSidebarOpen(false))}
            />
            <aside className={`${css.sidebar} ${isOpen ? css.sidebar_open : ''}`}>
                {auth && (
                    <>
                        <SidebarButtonsWrapper>
                            <SidebarWorkspaceButton />
                        </SidebarButtonsWrapper>
                        <SidebarButtonsWrapper>
                            <SidebarPlateButton />
                            <SidebarTeamButton />
                            <SidebarProjectsButton />
                            <SidebarAllTasksButton />
                        </SidebarButtonsWrapper>
                    </>
                )}
                <SidebarButtonsWrapper position="bottom">
                    {auth && <SidebarSearchButton />}
                    {auth && <SidebarInboxButton />}
                    <SidebarAuthButton />
                </SidebarButtonsWrapper>
            </aside>
        </>
    )
}

export default MobileSidebar
